import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';

@Injectable({
	providedIn: 'root',
})
export class OrderIssueChatService extends BaseService {
	protected readonly EndPoint = environment.API_ENDPOINT + 'orderIssueChats/';

	constructor(protected readonly http: HttpClient) {
		super(http);
	}

	filter(
		option: {
			take?: any;
			page?: any;
			searchTerm?: any;
			isActive?: any;
			orderIssue?: any;
		} = {}
	): Observable<any> {
		return this.http.get(
			`${this.EndPoint}filter?take=${option.take || ''}&page=${
				option.page || ''
			}&searchTerm=${option.searchTerm || ''}&isActive=${
				option.isActive || ''
			}&orderIssue=${option.orderIssue || ''}`
		);
	}
}
